<template>
  <a href="javascript:;" title="Exportar" @click="modalOpen('code');codeSetupBox(box)" class="option">
    <i class="kp-panel-import"></i> {{ $t('general.actions.export') }} Box
  </a>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  methods: mapActions([
    'modalOpen',
    'codeSetupBox',
  ]),
  props: [
    'box',
  ],
};
</script>



/** WEBPACK FOOTER **
 ** ExportBox.vue?24c1814a
 **/